import React from 'react';

import { useLocation, useParams } from '@thd-olt-component-react/router';
import Pip from '../app/components/pip';

// eslint-disable-next-line react/prop-types
export const PipApp = () => {
  let location = useLocation();
  let match = useParams();

  return (
    <>
      <Pip location={location} match={match} />
    </>
  );
};

PipApp.propTypes = {};

PipApp.displayName = 'PipPage';

PipApp.defaultProps = {};
